var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13851_58382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99995 5.1654V7.49874M6.99995 9.83207H7.00578M6.00245 2.16707L1.06162 10.4154C0.959749 10.5918 0.905848 10.7918 0.905278 10.9955C0.904708 11.1993 0.957487 11.3996 1.05837 11.5765C1.15925 11.7535 1.30471 11.901 1.48028 12.0043C1.65585 12.1076 1.85542 12.1632 2.05912 12.1654H11.9408C12.1445 12.1632 12.344 12.1076 12.5196 12.0043C12.6952 11.901 12.8407 11.7535 12.9415 11.5765C13.0424 11.3996 13.0952 11.1993 13.0946 10.9955C13.0941 10.7918 13.0402 10.5918 12.9383 10.4154L7.99745 2.16707C7.89346 1.99563 7.74704 1.85389 7.57231 1.75552C7.39759 1.65715 7.20046 1.60547 6.99995 1.60547C6.79944 1.60547 6.60231 1.65715 6.42759 1.75552C6.25286 1.85389 6.10644 1.99563 6.00245 2.16707Z",
    stroke: "#F79009",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13851_58382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alertWarning.05e72d8973bfb171ddcbda7af4329b06.svg";
export { ForwardRef as ReactComponent };